<template>
    <div class="main">
        <Table
            :columns="columns"
            :request="request"
            row-key="id"
            :searchData ="searchData"
            :formData="formData"
			ref="tableref"
        >
        <template v-slot:formItem>
           <a-form-model-item >
               <a-input v-model="searchData.name" allowClear  placeholder="请输入工地名称"/>
           </a-form-model-item> 
        </template>

        <template v-slot:tableAction="{record,showModal,showDelConfirm}">
           <a class="tAction" @click="wpUpdate(record,showModal)"><a-icon type="edit" />修 改</a>
           <a-divider type="vertical" />
           <a class="tAction" @click="wpDelete(record,showDelConfirm)"><a-icon type="delete" /> 删 除</a>
           <a-divider type="vertical" />
           <a class="tAction" @click="showauth(record)"> 权限分配 </a>
        </template>
        <template v-slot:tableIndex="index">
            {{index+1}}
        </template>

        <template v-slot:addAction="{showModal}">
            <a-form-model-item>
                <a-button type="primary" @click="wpAdd(showModal)"><a-icon type="plus" /> 添加</a-button>
            </a-form-model-item>
        </template>
        <template v-slot:itemFormData>
            <a-form-model-item label="工地名称">
                <a-input placeholder="请输入工地名称" v-model="formData.name"></a-input>
            </a-form-model-item>
            <a-form-model-item label="备注">
                <a-input placeholder="请输入备注" v-model="formData.note"></a-input>
            </a-form-model-item>
        </template>
        </Table>
		<Auth ref="auth" ></Auth>
    </div>
</template>

<script>
import Table from "@/components/AdvanceTable"
import {getList,addWP,updateWP,deleteWP} from "@/api/workplace.js"
import {getSearchParm} from "@/utils/index.js"
import Auth from './auth/auth.vue'
const columns = [
    {dataIndex:"id",key:"id",title:"序号",scopedSlots: { customRender: 'tindex' }},
    {dataIndex:"name",key:"name",title:"工地名称"},
    {dataIndex:"note",key:"note",title:"备注"},
    {key:"action",title:"操作",scopedSlots:{customRender:"action"}},
]
let user = sessionStorage.getItem("userinfo")
user = JSON.parse(user)
export default {
    data(){
        return {
            columns,
            request:{
                "get":getList,
                "add":addWP,
                "update":updateWP,
                "delet":deleteWP
            },
            searchData:getSearchParm({
                name:"",
				cmpid:user.cmpid
            }),
            formData:{
                name:"",
                note:""
            }
        }
    },
    components:{
        Table,
		Auth
    },
    computed:{
        
    },
    methods:{
        wpUpdate(record,showModal){
            this.formData = {...record}
            console.log(record)
            showModal("修改工地信息",[
                {"value":"name","text":"工地名称"}
            ])
        },
        wpAdd(showModal){
            this.formData = {
				cmpid:user.cmpid
			}
            showModal("添加工地",[
                {"value":"name","text":"工地名称"}
            ])
        },
        wpDelete(record,showDelConfirm){
            console.log(record)
            this.formData = {...record}
            showDelConfirm()
        },
		showauth(record){
			this.$refs.auth.showAuth(record,this.$refs.tableref.getSearchData)
		}
    }
}
</script>

<style lang="less" scoped>
@import "./index";
</style>
